import { defineManifest } from './manifest.js';

/** Platform-owned vocabulary. Modules add their own types and predicates in their manifests. */
export const coreManifest = defineManifest({
  id: 'core',
  version: '1.0.0',
  platformContract: '1',
  name: 'Workspace',
  description: 'Identity, people, relationships and shared services.',
  routes: ['/', '/settings'],
  collections: [
    'core_users', 'core_workspaces', 'core_memberships', 'core_preferences', 'core_people',
    'core_module_installations', 'core_entities', 'core_relations', 'core_outbox', 'core_event_receipts',
    'core_projection_state', 'core_assets', 'core_integration_connections', 'core_integration_cache',
    'core_jobs', 'core_activity', 'core_migrations', 'core_sessions',
  ],
  entityTypes: [
    {
      typeKey: 'core:person',
      label: 'Person',
      pluralLabel: 'People',
      appearance: { color: '#F2B872', shape: 'ring' },
      routeTemplate: '/people/:id',
    },
  ],
  predicates: [
    {
      id: 'core:related_to',
      label: 'related to',
      inverseLabel: 'related to',
      directed: false,
      from: '*',
      to: '*',
      allowManual: true,
    },
    {
      id: 'core:about',
      label: 'is about',
      inverseLabel: 'is the subject of',
      directed: true,
      from: '*',
      to: ['mind-networks:concept'],
      allowManual: true,
    },
  ],
  publicCapabilities: [
    'people.resolve@1',
    'entities.preview@1',
    'relations.create@1',
    'relations.delete@1',
    'graph.query@1',
  ],
  requires: [],
  optional: [],
  contributions: ['search', 'entityPreviews', 'graph', 'export'],
  events: { emits: ['core.person.changed.v1'], consumes: [] },
});
